import { Button, FormGroup, Input, Label } from 'reactstrap'
import { useCallback, useMemo, useState } from 'react'
import { CardElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import {Validator, ValueValidator} from "react-admin-base-bootstrap";

const CardElementOptions = {
  hidePostalCode: true,
  style: {
    base: {
      lineHeight: '1.429',
      fontSize: '16px',
      color: '#424770',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

function ValidatedCardElement() {
  const [ state, setState ] = useState();

  return <ValueValidator name="Card" value={state} type="required|card">
    <div className="form-control">
      <CardElement
        options={CardElementOptions}
        onChange={setState}
      />
    </div>
  </ValueValidator>;
}

export function CreditCard({ onSubmit }) {
  const [ loading, setLoading ] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [ name, setName ] = useState('');

  const handlePayment = useCallback(async function(e) {
    e.preventDefault();

    setLoading(true);
    try {
      const cardElement = elements.getElement(CardElement);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });
      
      if (error) {
        console.error(error);
        return ;
      }

      try {
        await onSubmit({
          stripe: {
            payment_method_id: paymentMethod.id
          }
        });
      } catch (e) {
        if (e.name !== 'PaymentActionRequired')
          throw e;

        const { paymentIntent, error } = await stripe.handleCardAction(e.data);
        if (error)
          throw error;

        await onSubmit({
          stripe: {
            payment_intent_id: paymentIntent.id
          }
        });
      }
    } finally {
      setLoading(false);
    }
  }, [stripe, elements, onSubmit, setLoading ]);

  return <div className="credit-card">
    <FormGroup>
      <Label>Card number</Label>
      <ValidatedCardElement />
    </FormGroup>
    <FormGroup>
      <Label>Full name</Label>
      <Validator name="complete" type="required">
        <Input
          type="text"
          disabled={loading}
          value={ name || '' }
          onChange={a => setName(a.currentTarget.value) }
        />
      </Validator>
    </FormGroup>
    <Button color="primary" block disabled={loading} onClick={handlePayment}>
      { loading ? <i className="fas fa-spin fa-spinner" /> : 'Complete Payment' }</Button>
  </div>;
}

export default function CreditCardLoader(props) {
  const stripe = useMemo(() => loadStripe("pk_test_51JBXMSGWozTtlun232Jx1ua0NhTr6BQrcSWbp5ElP4RpFgXrQTHVmBf4ECffn2Imt1NrmJU6HEQSaL5JcqFUyVSY00v6Na20S8"), [ ]);

  return <Elements stripe={stripe}>
    <CreditCard {...props} />
  </Elements>;
}
